// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + (chunkId === 594 ? "about" : chunkId) + "." + {"412":"68b8ca9c","594":"6a25b45e","701":"ebeff63d","981":"e546babb"}[chunkId] + ".css";
};